import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React, { FunctionComponent, memo, useMemo, useState } from 'react';

import { escapeRegExp } from '../../../../../utils/escapeRegExp';
import TextInput from '../../inputs/text';

import DefaultList, { CategoryListProps } from './default-list';
import FilteredList from './filtered-list';
import classes from './navigation.module.css';
import SearchInput from '../../../../pages/v2/vehicle/search-input';
import ChangeCar from '../../../../pages/v2/categories/change-car';
import { originalRoutes } from '../../../../../hooks/use-link-props';
import { useFilteredGroups } from '../../../inputs/filters/parts/use-filtered-groups';

export type CategoryNavigationProps = {
  isSearchFullWidth?: boolean;
  showNoResultsButton?: boolean;
  replaceNavigationFn?: Function;
  slug?: string;
  isPartsMenu?: boolean;
  linkToNavigate?: keyof typeof originalRoutes;
  carInfo: any;
} & CategoryListProps;

const CategoryNavigation: FunctionComponent<CategoryNavigationProps> = ({
  isSearchFullWidth,
  showNoResultsButton = true,
  replaceNavigationFn,
  slug,
  isPartsMenu = false,
  carInfo,
  linkToNavigate,
  ...props
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>('');
  const filteredGroups = useFilteredGroups({ groups: props.groups, search });

  return (
    <section
      className={cx('h-full', 'grid', 'grid-rows-[48px_1fr]', 'items-start')}
    >
      <div className={cx('sticky w-full', 'top-0', 'z-10', 'bg-white')}>
        <div className={cx('container', 'w-full mx-auto')}>
          <div
            className={cx(
              'flex',
              'w-full',
              'mx-auto',
              isSearchFullWidth ? 'lg:w-full' : 'lg:w-1/2'
            )}
          >
            <SearchInput
              search={search}
              placeholder={t('common:filterByPart')}
              setSearch={setSearch}
              isFullWith={true}
            />
          </div>
        </div>
      </div>

      {carInfo && (
        <div className="w-full container m-auto pt-12 flex justify-center">
          <ChangeCar carInfo={carInfo} />
        </div>
      )}
      <div
        className={cx(
          'h-full',
          'w-full',
          'container',
          'mx-auto',
          'overflow-auto',
          isPartsMenu ? '' : 'mt-[32px] lg:mt-12'
        )}
      >
        {search ? (
          <FilteredList
            {...props}
            slug={slug}
            groups={filteredGroups}
            search={search}
            showNoResultsButton={showNoResultsButton}
            replaceNavigationFn={replaceNavigationFn}
            isPartsMenu={isPartsMenu}
            linkToNavigate={linkToNavigate}
            vehicle={carInfo}
          />
        ) : (
          <DefaultList
            {...props}
            slug={slug}
            replaceNavigationFn={replaceNavigationFn}
            isPartsMenu={isPartsMenu}
            linkToNavigate={linkToNavigate}
            vehicle={carInfo}
          />
        )}
      </div>
    </section>
  );
};

export default memo(CategoryNavigation);
